import isInAnyVariant from './isInAnyVariant'

export enum POSSIBLE_VARIANTS {
  B = 'B',
  C = 'C'
}

// CAT-1064
const AB_TEST_LOADING_PAGE = [
  {
    id: 609,
    env: 'shared'
  },
  {
    id: 1209,
    env: 'stage'
  },
  {
    id: 1187,
    env: 'production'
  }
]

export const isInABTestLoadingPageVariantB = () =>
  isInAnyVariant(AB_TEST_LOADING_PAGE)

const AB_TEST_IBAN_TEXT_DELETE = [
  {
    id: 613,
    env: 'shared'
  },
  {
    id: 1214,
    env: 'stage'
  },
  {
    id: 1191,
    env: 'production'
  }
]

export const isInABTestDeleteIBANTextVariantB = () =>
  isInAnyVariant(AB_TEST_IBAN_TEXT_DELETE)

const ABC_TEST_CARROT2_LOADING_PAGE_VARIANT = {
  [POSSIBLE_VARIANTS.B]: [
    {
      id: 620,
      env: 'shared'
    },
    {
      id: 1221,
      env: 'stage'
    },
    {
      id: 1198,
      env: 'production'
    }
  ],
  [POSSIBLE_VARIANTS.C]: [
    {
      id: 621,
      env: 'shared'
    },
    {
      id: 1222,
      env: 'stage'
    },
    {
      id: 1199,
      env: 'production'
    }
  ]
}

export const isInCarrot2LoadingVariant = (variant: POSSIBLE_VARIANTS) =>
  isInAnyVariant(ABC_TEST_CARROT2_LOADING_PAGE_VARIANT[variant])

const AB_TEST_PROGRESS_BAR_STYLE_VARIANT_B = [
  {
    id: 618,
    env: 'shared'
  },
  {
    id: 1219,
    env: 'stage'
  },
  {
    id: 1196,
    env: 'production'
  }
]

export const isInABTestProgressBarStyleVariantB = () =>
  isInAnyVariant(AB_TEST_PROGRESS_BAR_STYLE_VARIANT_B)
